import { styled, Box, StyleSystemProps, Flex } from '@withjoy/joykit';

export const StyledTrendsContainer = styled(Box)``;
export const StyledOptionWrapper = styled(Flex)`
  &:hover {
    color: #4751f8;
    color: color(display-p3 0.3059 0.0235 0.949);
    &svg {
      color: #4751f8;
      color: color(display-p3 0.3059 0.0235 0.949);
    }
  }
`;

const trendsContainerStyles: StyleSystemProps = {
  width: '100%',
  top: '3.5rem',
  paddingX: 0,
  borderRadius: 4,
  position: 'absolute',
  zIndex: 'dropdown',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04)',
  backgroundColor: 'white',
  paddingBottom: 3,
};

const searchTermStyles = {
  paddingX: 6,
  paddingY: 2,
  gap: 2,
  cursor: 'pointer',
  color: 'mono10',
  _hover: {
    backgroundColor: 'mono2',
    color: 'color(display-p3 0.3059 0.0235 0.949)',
  },
  _active: {
    backgroundColor: 'mono4',
    color: 'color(display-p3 0.3059 0.0235 0.949)',
  },
  ['& > svg']: {
    color: 'mono14',
    fill: 'mono14',
  },
  ['&:hover > svg']: {
    color: 'color(display-p3 0.3059 0.0235 0.949)',
    fill: 'color(display-p3 0.3059 0.0235 0.949)',
  },
};

const searchTermFontStyles: StyleSystemProps = {
  color: 'inherit',
  fontStyle: 'normal',
  lineHeight: '150%',
  letterSpacing: '-0.15px',
};

export const styles = { searchTermStyles, searchTermFontStyles, trendsContainerStyles };
